import { Link } from "react-router-dom";
import { FileText } from 'lucide-react';
import styles from '../styles/pages/SiteMap.module.css';

const SiteMap = () => {
  const cardStyle = {
    background: '#fff',
    padding: '2rem',
    borderRadius: '0.7rem',
    margin: '2rem auto',
    maxWidth: '1000px',
    boxShadow: '0 4px 12px rgba(1, 31, 55, 0.08)',
    borderLeft: '0.2rem solid #011F37',
    borderRight: '0.2rem solid #011F37'
  };

  const titleStyle = {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#011F37',
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  };

  const listStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0
  };

  const listItemStyle = {
    marginBottom: '1rem',
    padding: '0.5rem 0',
    borderBottom: '1px solid #eee'
  };

  const linkStyle = {
    color: '#011F37',
    textDecoration: 'none',
    fontSize: '1.1rem',
    display: 'block',
    padding: '0.5rem 0',
    transition: 'color 0.2s ease'
  };

  return (
    <div>
      {/* Header Section */}
      <section className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>Plan du site</h1>
        </div>
      </section>
      
      {/* Content Section */}
      <section style={{ padding: '2rem' }}>
        <div style={cardStyle}>
          <h2 style={titleStyle}>
            <FileText size={24} />
            Navigation du site
          </h2>
          <ul style={listStyle}>
            <li style={listItemStyle}>
              <Link to="/" style={linkStyle}>Accueil</Link>
            </li>
            <li style={listItemStyle}>
              <Link to="/services" style={linkStyle}>Services</Link>
            </li>
            <li style={listItemStyle}>
              <Link to="/achievements" style={linkStyle}>Réalisations</Link>
            </li>
            <li style={listItemStyle}>
              <Link to="/contact" style={linkStyle}>Contact</Link>
            </li>
            <li style={listItemStyle}>
              <Link to="/legale-notice" style={linkStyle}>Mentions légales</Link>
            </li>
            <li style={{ ...listItemStyle, borderBottom: 'none' }}>
              <Link to="/site-map" style={linkStyle}>Plan du site</Link>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default SiteMap;